"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_router_1 = require("react-router");
var bind_1 = require("../bind");
var search_input_group_1 = require("../cms/search_input_group");
var with_update_url_1 = require("./with_update_url");
function getValue(filter) {
    return filter.options[0].setValues[0];
}
var TextInputFacet = /** @class */ (function (_super) {
    tslib_1.__extends(TextInputFacet, _super);
    function TextInputFacet(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { text: getValue(props.filter) || '' };
        return _this;
    }
    TextInputFacet.prototype.componentWillReceiveProps = function (nextProps) {
        var newValue = getValue(nextProps.filter);
        if (newValue !== getValue(this.props.filter)) {
            this.setState({ text: newValue });
        }
    };
    TextInputFacet.prototype.handleSubmit = function (evt) {
        var _a;
        evt && evt.preventDefault();
        var paramName = this.props.filter.options[0].paramName;
        var newUrl = this.props.updateUrl(this.props.location, (_a = {},
            _a[paramName] = this.state.text,
            _a));
        this.props.router.push(newUrl);
    };
    TextInputFacet.prototype.handleClear = function () {
        var _this = this;
        this.setState({ text: '' }, function () {
            // Submit on clear if there is currently a non-empty filter applied
            getValue(_this.props.filter) && _this.handleSubmit(null);
        });
    };
    TextInputFacet.prototype.handleChange = function (evt) {
        this.setState({ text: evt.target.value });
    };
    TextInputFacet.prototype.render = function () {
        return (React.createElement("div", { className: "facet" },
            React.createElement("div", { className: "facet__heading" }, this.props.filter.name),
            React.createElement(search_input_group_1.default, { onSubmit: this.handleSubmit, onChange: this.handleChange, onClear: this.handleClear, value: this.state.text })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], TextInputFacet.prototype, "handleSubmit", null);
    tslib_1.__decorate([
        bind_1.default
    ], TextInputFacet.prototype, "handleClear", null);
    tslib_1.__decorate([
        bind_1.default
    ], TextInputFacet.prototype, "handleChange", null);
    return TextInputFacet;
}(React.Component));
exports.TextInputFacet = TextInputFacet;
exports.default = react_router_1.withRouter(with_update_url_1.withUpdateURL(TextInputFacet));
//# sourceMappingURL=text_input_facet.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/text_input_facet.js
// module id = LGuK
// module chunks = 0 1 2 3 9 10 14 20